import React, { useEffect, useState } from "react";
import "../../CSS/PreModal.css";
import Select, { StylesConfig } from "react-select";
import {
  ColourOption,
} from "../../Selecteddata/data";
import chroma from "chroma-js";
import { toast } from "react-hot-toast";
import { API_BASE_URL } from "../../config/serverApiConfig";
import ProfileLoader from "../../components/Loader/ProfilesLoader";
import { motion } from "framer-motion";
import Cookies from "js-cookie";

function PreModal({ props, closepreModal }) {
  const notifyCandidatMovedSuccess = () =>
    toast.success("Candidate Pre-Selected Successfully!");
  const notifyCandidatMovedError = () =>
    toast.error("Candidate cannot be Pre-Selected at the moment! Please Try Again.");
  const [selectedClient, setSelectedClient] = useState("");
  const [showReason, setShowReason] = useState(false);
  const [reason, setReason] = useState("");
  const [clientDataOptions, setClientOption] = useState([]);
  const [data, setData] = useState([]);
  const [Client, setClients] = useState([]) as any;
  const [btnLoader, setbtnLoader] = useState(false);
  const [btnDisabled, setbtnDisabled] = useState(false);

  if (clientDataOptions.length == 0 && Client.length > 0) {
    setClientOption(
      Client
        ? Client.map((client) => {
          return {
            label:
              client.clientCompanyName.toLocaleUpperCase() +
              ` (${client.jobStatus})`,
            value: client._id,
            color: "#FF8B00",
          };
        })
        : props.clients
          ? props.clients.map((client) => {
            return {
              label:
                client.clientCompanyName.toLocaleUpperCase() +
                ` (${client.jobStatus})`,
              value: client._id,
              color: "#FF8B00",
            };
          })
          : [{ label: "No Clients In this Sector", value: "", color: "#FF8B00" }]
    );
  }

  const fetchProfilesClients = async () => {
    return await fetch(API_BASE_URL + "getProfiles", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
    })
      .then((resD) => resD.json())
      .then((reD) => reD)
      .catch((err) => err);
  };

  useEffect(() => {
    if (data.length == 0) {
      fetchProfilesClients()
        .then((filteredresponse) => {
          setData([...filteredresponse.data]);
          setbtnDisabled(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (Client.length == 0) {
      let FilDataCName = data.filter((el) => {
        if (el.clientCompanyName && el.jobStatus !== "Archived") {
          return el.clientCompanyName;
        } else {
          return;
        }
      });
      setClients([...FilDataCName]);
    }
  }, [data]);

  const onClientChange = (sc: any) => {
    setSelectedClient(sc.value);
    setShowReason(true);
  };

  const onDataChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | any
    >
  ) => {
    // debugger
    setReason(e.target.value);
  };

  const changeStatus = async (preSelectedData: any) => {
    return await fetch(API_BASE_URL + "moveToPreSelected", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
      body: JSON.stringify(preSelectedData),
    })
      .then((resp) => resp.json())
      .then((respData) => respData)
      .catch((err) => err);
  };

  const moveToPreSelected = () => {
    setbtnDisabled(true);
    const preSelectedData = {
      candidatId: props._id,
      clientId: selectedClient,
      reason: reason,
    };
    changeStatus(preSelectedData)
      .then((resData) => {
        setbtnLoader(true);
        if (resData.status) {
          notifyCandidatMovedSuccess();
          setTimeout(() => {
            window.location.href = `/candidate/profile/${props._id}`;
          }, 2000);
          setbtnLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        notifyCandidatMovedError();
        setbtnLoader(false);
      });
  };

  const colourStyles: StylesConfig<ColourOption, true> = {
    control: (styles) => ({ ...styles, backgroundColor: "white" }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = chroma(data.color);
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
            ? data.color
            : isFocused
              ? color.alpha(0.1).css()
              : undefined,
        color: isDisabled
          ? "#ccc"
          : isSelected
            ? chroma.contrast(color, "white") > 2
              ? "white"
              : "black"
            : data.color,
        cursor: isDisabled ? "not-allowed" : "default",
        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : color.alpha(0.3).css()
            : undefined,
        },
      };
    },
    multiValue: (styles, { data }) => {
      const color = chroma(data.color);
      return {
        ...styles,
        backgroundColor: color.alpha(0.1).css(),
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: data.color,
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: data.color,
      ":hover": {
        backgroundColor: data.color,
        color: "white",
      },
    }),
  };

  return (
    <div
      className="modal d-block tw-fixed !important tw-top-1/4 !important"
    >
      <div className="modal-dialog shadow-lg tw-rounded-xl !important">
        <div className="modal-content" style={{ width: "670px" }}>
          <div className="modal-header">
            <h5
              className="modal-title modalStylingfont tw-items-center"
              id="exampleModalLabel"
            >
              Move <span className="tw-text-green-500 !important tw-mx-1 !important"> {props.candidatName} </span> to Documents Collecting Stage
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                closepreModal(false);
              }}
            ></button>
          </div>
          <div className="modal-body">
            <p className="ChildStylePreModal">
              For which Client, {props.candidatName} is selected?
            </p>
            <div>
              {clientDataOptions.length > 0 ? (
                <Select
                  name="clientCompanyName"
                  closeMenuOnSelect={true}
                  placeholder="Select A Client"
                  className="basic-select preSelectModal"
                  classNamePrefix="select"
                  styles={colourStyles}
                  onChange={onClientChange}
                  options={clientDataOptions}
                />
              ) : (
                <div className="col-12">
                  {" "}
                  <ProfileLoader
                    width={150}
                    height={"40px"}
                    fontSize={"20px"}
                    fontWeight={"600"}
                    Title={""}
                  />{" "}
                </div>
              )}
            </div>

            {
              showReason ? (
                <textarea rows={3} className="tw-w-full tw-mt-3 tw-p-2 tw-rounded-md tw-border tw-border-gray-300 tw-shadow-sm focus:tw-outline-none" placeholder="Reason for Pre-Selecting Candidate" onChange={onDataChange}>
                </textarea>
              ) : null
            }
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn preSelectedStageBtn d-flex hover:tw-shadow-xl !important"
              disabled={btnDisabled}
              onClick={moveToPreSelected}
            >
              {btnLoader ? (
                <div className="RESTloader ">Loading...</div>
              ) : null}{" "}
              Pre-Select {props.candidatName}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PreModal;
